export default __webpack_public_path__ + "static/media/roboto-condensed-v19-latin-700italic.d58264d9.woff";